import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSetPosModal } from "../atoms/usePosModal";
import useLocationHook from "./useLocationHook";
import { useSetModal } from "../atoms/useModal";
import { useSetPosOrderDeliveryMethod } from "../atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods } from "../utils/enum";

const useVoipApproveHandlerHook = () => {
  const { isLivePage } = useLocationHook();
  const setPosOrder = useSetPosModal();
  const router = useHistory();
  const setModal = useSetModal();
  const setDeliveryMethod = useSetPosOrderDeliveryMethod();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const approveHandler = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (isLivePage) {
      setPosOrder(true);
    } else {
      router.push("/orders/pos-order");
    }

    timeoutRef.current = setTimeout(() => {
      setDeliveryMethod(DeliveryMethods.DELIVERY);
      setModal("orderUser", { deliveryMethodId: DeliveryMethods.DELIVERY });
    }, 500);
  };

  return approveHandler;
};

export default useVoipApproveHandlerHook;
